const isUserAccessToRoleError = message => {
  return message.match(/user doesn't have access to role/i)
}
const isUserAccessToResourceError = message => {
  return message.match(/User does not have access to/i)
}

export const getErrorStatusCode = error => {
  const status = error?.status ?? error?.statusCode
  if (status) {
    return status
  }

  const messagesToCheck = [error?.message, error?.internalMessage].filter(
    Boolean,
  )

  for (const message of messagesToCheck) {
    if (
      isUserAccessToRoleError(message) ||
      isUserAccessToResourceError(message)
    ) {
      return 401
    }
    if (
      message.includes('Site with licenseId') &&
      message.includes('does not exist in the database')
    ) {
      return 404
    }
  }

  return 500
}
